/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAvalara = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m13.417 2 3.213 7.652c-.912.74-1.78 1.523-2.576 2.32L12.26 7.739l-.29-.767h-.16l-.289.767L5.487 22H2l8.35-20zm8.364 20h-3.487l-1.925-4.565a34.37 34.37 0 0 1 2.345-2.797z" />
        <path d="M19.277 11.45c-4.384 4.1-6.511 8.477-7.38 9.955-.448-.754-1.258-2.333-2.488-4.159l.854-2.015c.603.677 1.62 1.925 1.635 1.943 1.606-2.058 4.037-4.753 6.888-6.87z" />
      </g>
    </g>
  </Icon>
);
export { SvgAvalara as Avalara };
